import PageLayout from "@/pages/home/components/PageLayout";
import VideoSection from "@/pages/home/components/VideoSection";

export default function VideoPage() {
  return (
    <PageLayout>
      <VideoSection />
    </PageLayout>
  );
}
